module.exports = __webpack_public_path__ + "img/T1D_xh1.eafd3624.png";